import { render, staticRenderFns } from "./BidReports.vue?vue&type=template&id=3dbff25b&scoped=true"
import script from "./BidReports.vue?vue&type=script&lang=js"
export * from "./BidReports.vue?vue&type=script&lang=js"
import style0 from "./BidReports.vue?vue&type=style&index=0&id=3dbff25b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbff25b",
  null
  
)

export default component.exports